export default __webpack_public_path__ + "static/media/1079.aefa231c.png";